import React from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import refresh from '../../../assets/icons/servTopics/refresh.svg'
import { StyledTableCell, StyledTableRow, useStyles } from './PartitionStyle';
import { Paper } from '@material-ui/core';
export default function Partitons() {
    const heading = [
        "Patition",
        "ISR",
        "Size",
        "First offset",
        "Last offset"
    ]
    const data = [
        {
            partition: "1",
            isr: "3/3",
            size: "0 Bytes",
            firstOffset: "0",
            lastOffset: "0"
        },

        {
            partition: "2",
            isr: "3/4",
            size: "1 Bytes",
            firstOffset: "3",
            lastOffset: "2"
        },



    ]
    const style = useStyles()
    return (
        <div>
            <div className={style.partitionDiv}>
                <div className={style.partitiontxt}>
                Patitions
                </div>
                <div className={style.refreshIcon}><img src={refresh}/></div>
            </div>
            <TableContainer component={Paper} className={style.eventContainer} >
                <Table className={style.table} size="medium" aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            {
                                heading?.map((item) => {
                                    return (
                                        <StyledTableCell>{item}</StyledTableCell>
                                    )
                                })
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {
                            data?.map((item, i) => {
                                    return (
                                        <StyledTableRow key={i}>
                                            <StyledTableCell >{item?.partition}</StyledTableCell>
                                            <StyledTableCell >{item?.isr}</StyledTableCell>
                                            <StyledTableCell >{item?.size}</StyledTableCell>
                                            <StyledTableCell >{item?.firstOffset}</StyledTableCell>
                                            <StyledTableCell >{item?.lastOffset}</StyledTableCell>
                                        </StyledTableRow>
                                    )
                                })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}
